import videoPoster from '../../../utils/images/video-poster.png'
// import cosmosVideo from '../../../utils/videos/COSMOS CONFERENCE 2024.mp4'

import './homepage.css';

const VideoInfoSection = () => {
  return (
    <section className='video-section mb-5 pb-5'>
        {/* <marquee behavior="" direction="">
          Happening Live @ Light Place Event Center, Abijan Street Wuse 3, Abuja 
        </marquee> */}
        <div className="marquee-section my-5 py-2">
          <span className='marquee custom-cosmos'>
            Happening Live @ Light Place Event Center, Abijan Street Wuse 3, Abuja &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            Happening Live @ Light Place Event Center, Abijan Street Wuse 3, Abuja &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            Happening Live @ Light Place Event Center, Abijan Street Wuse 3, Abuja &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            Happening Live @ Light Place Event Center, Abijan Street Wuse 3, Abuja &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          </span>
        </div>

        <div className="video-text custom-cosmos my-5">
          <p className="text-center pt-5 mt-5 pb-2 pb-md-5 px-3 js-scroll fade-in">The Cosmos Conference is a global event designed to bring the creator's mindset into the mainstream as a failproof for individuals in their respective fields. </p>
        </div>

        <div className="video-display page-width px-3 js-scroll fade-in-bottom mb-0 mb-md-5 pb-0 pb-md-5">
          {/* <video width="100%" height="100%" className='custom-video' poster={videoPoster} autoPlay muted controls loop >
            <source src={cosmosVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video> */}
          <div className='video-display' style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              src="https://www.youtube.com/embed/UrOvKF9QmPw?autoplay=1&mute=1&loop=1&playlist=UrOvKF9QmPw&rel=0"
              title="Cosmos Conference Video"
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className='custom-video'
            ></iframe>
          </div>
        </div>

    </section>
  )
}

export default VideoInfoSection